import React from 'react';

import { DevDocsScmProviderIcon } from '../DevDocsScmProviderIcons.tsx';
import {
	getDevDocsSourceProviderConfigFromValue,
	getDevDocsSourceProviderDisplayName,
} from '../source-resolution/devDocsSourceProviders.ts';

import type { DevDocsBylineConnection } from './devDocsConnections.ts';

const getIconKey = (providerDisplayName: string | null): string =>
	providerDisplayName?.replace(/([a-z])([A-Z])/g, '$1 $2') ?? 'Repository';

const getProviderIcon = (provider: string | null, providerDisplayName: string) => {
	return {
		key: `devdocs-provider-${getIconKey(providerDisplayName)}`,
		kind: 'element' as const,
		label: providerDisplayName,
		node: <DevDocsScmProviderIcon provider={provider} />,
	};
};

export const getDevDocsProviderIcon = (
	connection: DevDocsBylineConnection | null,
): {
	key: string;
	label: string;
	icon: {
		key: string;
		kind: 'element';
		label: string;
		node: React.JSX.Element;
	};
} | null => {
	if (!connection) {
		return null;
	}

	const providerConfig = getDevDocsSourceProviderConfigFromValue(connection.provider);
	const providerDisplayName =
		providerConfig?.displayName ?? getDevDocsSourceProviderDisplayName(connection.provider);

	if (!providerDisplayName) {
		return null;
	}

	return {
		key: providerConfig ? getIconKey(providerConfig.displayName) : providerDisplayName,
		label: providerDisplayName,
		icon: getProviderIcon(connection.provider, providerDisplayName),
	};
};
